import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
// this is for demo purpose only / change for further api calls
import { API_ROUTES } from '../../../utility/api.routes'
import { formatDateToUTC } from '../../../utility/genricFunction'
import { toast } from 'react-toastify'
import { setInquiryPageData } from '../../slice/inquiry/inquiry.slice'
import { ROUTES_PATH } from '../../../utility/constants'


const constructQueryParams = (filters) => {
  const params = new URLSearchParams();
  Object.keys(filters).forEach((key) => {
      if (filters[key].value !== null && filters[key].value !== undefined && filters[key].value !== '') {
          params.append(key,  filters[key].value);
      }
  });
  return params.toString();
};

export const getInquiries = createAsyncThunk('inquiry/getInquiries', async (filterData,{dispatch}) => {
  try {
// const dispatch=useDispatch()

    // let query = ''
    // for (const key in filterData) {
    //     query += `${key}=${filterData[key]}&`
    // }
    // query = query.slice(0, -1)
    const queryParams = constructQueryParams(filterData);
    // i am setting this to check async call....
    const url = API_ROUTES.INQUIRY.GET_INQUIRY(queryParams)
    const response = await apiClient.get(url)
    response?.data?.result?.inquiries?.forEach(inquiry => {
      const date = inquiry.inquiryDate !== null && new Date(inquiry.inquiryDate);
      const date2 = inquiry.nextFollowupDate !== null && new Date(inquiry.nextFollowupDate);
      inquiry.inquiryDate = inquiry.inquiryDate !== null ? formatDateToUTC(date): inquiry.inquiryDate
      inquiry.nextFollowupDate = inquiry.nextFollowupDate !== null ? formatDateToUTC(date2): inquiry.nextFollowupDate
    });   
    dispatch(setInquiryPageData(response?.data?.result));
    return response?.data?.result?.inquiries
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const createInquiry = createAsyncThunk('inquiry/createInquiry', async ({values,navigate}, { dispatch }) => {
  try {
    const url = API_ROUTES.INQUIRY.POST_INQUIRY
     const response = await apiClient.post(url, values)
     if(response?.status){
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
      navigate(ROUTES_PATH.INQUIRY)
    }
  } catch (error) {
    toast.error(error.response.data.message,{
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    console.error('builder function error:', error)
    throw error
  }
})

export const editInquiry = createAsyncThunk('inquiry/editInquiry', async ({values,navigate}, { dispatch }) => {
  const url = API_ROUTES.INQUIRY.PUT_INQUIRY
  try {
    const response = await apiClient.put(url, values)
    if(response?.status){
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
      navigate(ROUTES_PATH.INQUIRY)
    }
  } catch (error) {
    toast.error(error.response.data.message,{
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    console.error('builder function error:', error)
    throw error
  }
})

export const inquiryArchive = createAsyncThunk('inquiry/inquiryArchive', async ( { inquiryId},{dispatch}) => {
  try {
    const url = API_ROUTES.INQUIRY.POST_INQUIRY_ARCHIVE(inquiryId)
    await apiClient.post(url,{ inquiryArchiveStatus: 'archive'})
    // dispatch(getInquiries({}))
    // navigate(ROUTES_PATH.INQUIRY)
  } catch (error) {
    toast.error(error.response.data.message,{
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    console.error('builder function error:', error)
    throw error
  }
})

export const getPriorityInquiries = createAsyncThunk('inquiry/getPriorityInquiries', async (filterData) => {
  try {
    let query = ''
    for (const key in filterData) {
        query += `${key}=${filterData[key]}&`
    }
    query = query.slice(0, -1)
    // i am setting this to check async call....
    const url = API_ROUTES.INQUIRY.GET_INQUIRY(query)
    const response = await apiClient.get(url)
    response?.data?.result?.inquiries?.forEach(inquiry => {
      const date = inquiry.inquiryDate !== null && new Date(inquiry.inquiryDate);
      const date2 = inquiry.nextFollowupDate !== null && new Date(inquiry.nextFollowupDate);
      inquiry.inquiryDate = inquiry.inquiryDate !== null ? formatDateToUTC(date): inquiry.inquiryDate
      inquiry.nextFollowupDate = inquiry.nextFollowupDate !== null ? formatDateToUTC(date2): inquiry.nextFollowupDate
    });   
    return response?.data?.result?.inquiries
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getInquirySources =  createAsyncThunk('inquiry/get-inquiry-sources', async () => {
  try {
    const response = await apiClient.get('/source')
    return response?.data?.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getInquiryById = createAsyncThunk('inquiry/getInquiryById', async (inquiryId) => {
  try {
    
    const url = API_ROUTES.INQUIRY.GET_INQUIRY_BY_ID(inquiryId)
    const response = await apiClient.get(url)   
    return response?.data?.result?.inquiries[0]
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})